import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApiService } from './api.service';
import { environment } from '@env/environment';
import { CreateStudentCoinDto } from '@app/infrastructure/models/coin';
import { UserStateService } from '../state/user-state.service';

@Injectable({
  providedIn: 'root',
})
export class StudentCoinService {
  private controllerRoute: string = 'students';
  private url: string = `${environment.apiRoute}`;
  private coinPurse$: BehaviorSubject<number> = new BehaviorSubject(0);

  public get coinPurseObs$(): Observable<number> {
    return this.coinPurse$.asObservable();
  }

  public get coinPurse(): number {
    return this.coinPurse$.getValue();
  }

  public set coinPurse(value: number) {
    this.coinPurse$.next(value);
  }

  constructor(
    private apiService: ApiService,
    private userStateService: UserStateService,
  ) {
    this.url = `${environment.apiRoute}/${this.controllerRoute}`;
  }

  public createCoin(
    payload: CreateStudentCoinDto,
  ): Observable<CreateStudentCoinDto> {
    const user = this.userStateService.userSession;
    if (!user?.student?.id) return;
    const endpoint = `${this.url}/${user.student.id}/coins`;
    this.addCoinToPurse(payload.amount);

    return this.apiService.post<CreateStudentCoinDto, CreateStudentCoinDto>(
      endpoint,
      payload,
    );
  }

  private addCoinToPurse(amount: number): void {
    this.coinPurse = this.coinPurse + amount;
    const user = this.userStateService.userSession;
    user.student.coinPurse = this.coinPurse;
    this.userStateService.setUserSession(user);
  }
}
